import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  recurringSchema,
  spainCorrectionCodeSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../../_shared/schemaHelpers";

export const siiCorrectiveInvoiceSchema: TSchemaBuilder = (t, ctx) =>
  documentInfoSchema({
    t,
    documentClass: "Invoice",
    poErrorKey: "poNumber_is_required",
    dueDateRequired: true,
    enforceDateOrder: true,
  })
    .concat(
      Yup.object({
        rectificationReason: Yup.string()
          .required(t("rectificationReason_is_required"))
          .typeError(t("rectificationReason_is_required")),
      }),
    )
    .concat(spainCorrectionCodeSchema(t, ctx.invoiceType === "regular"))
    .concat(customerSchema(t))
    .concat(vendorSchema(t))
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema())
    .concat(recurringSchema()) as Yup.ObjectSchema<any>;
